module.exports = __webpack_public_path__ + "media/images/icons/plus-gray-029afcdac5e69a864cfc572bc2d08efe.svg";